var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"diff-viewer",style:(_vm.containerStyle)},[_c('TextView',{attrs:{"text":_vm.displayContent,"shouldClamp":false,"numberOfLines":0,"fillHeight":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }